import { IoMdSearch } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setInterestingLinksQuery } from '../../app/features/interestingLinksSlice';
import '../Metasearcher/Metasearcher.css';

const InterestingLinksSearchBar = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { query } = useSelector((state) => state.interestingLinks);

	return (
		<form
			className='metasearchBarContainer'
			onSubmit={(e) => e.preventDefault()}
		>
			<input
				type='text'
				value={query}
				onChange={(e) => dispatch(setInterestingLinksQuery(e.target.value))}
				placeholder={t('Do a search')}
				className='metasearchBar'
			/>
			<button className='metasearchButton' type='submit'>
				<IoMdSearch />
				<p>{t('Search')}</p>
			</button>
		</form>
	);
};

export default InterestingLinksSearchBar;
